import React, { useEffect, useState } from 'react'
import axios from "./../../../axios";
import { toast } from 'react-toastify';

function PlayerComponent({ videoId, clickedContent, contentProviderType }) {

    const [otp, setOtp] = useState('');
    const [playbackInfo, setPlaybackInfo] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [youtubeVideoId, setYoutubeVideoId] = useState("");

    const fetchVideoDetails = async () => {
        setLoading(true);
        if (videoId === null || videoId === undefined) {
            return;
        }
        try {
            const response = await axios.get(`/api/v1/getVideoDetails/${videoId}`);
            const { otp, playbackInfo } = response.data;
            setOtp(otp);
            setPlaybackInfo(playbackInfo);
        } catch (error) {
            console.error('Error fetching video details:', error);
            setError('Failed to load video details.');
        } finally {
            setLoading(false);
        }
    };

    const extractYouTubeVideoId = (iframeString) => {

        // Extract the `src` URL from the iframe
        const matchSrc = iframeString?.match(/src=["']([^"']+)["']/);
        if (!matchSrc) return null;

        const videoUrl = matchSrc[1]; // Extracted `src` URL

        // Extract the Video ID from YouTube Embed URL
        const matchId = videoUrl.match(/youtube\.com\/embed\/([^?]+)/);
        return matchId ? matchId[1] : null;
    };

    useEffect(() => {
        if (contentProviderType === "Weblink") {
            window.open(clickedContent.fileInfo.fileURL, "dikshTab");
        } else {
            const extractedId = extractYouTubeVideoId(clickedContent?.fileInfo?.fileURL);
            setYoutubeVideoId(extractedId);
        }
    }, [clickedContent]);

    useEffect(() => {
        if (videoId !== null || videoId !== undefined) {
            fetchVideoDetails();
        }
    }, [videoId]);


    // const videoSrc = videoId
    //     ? `https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}&primaryColor=4245EF`
    //     : `https://www.youtube-nocookie.com/embed/${youtubeVideoId}?autoplay=1`;

    if (loading) { <p style={{ padding: "5px", color: "#ffffff" }}>Loading...</p> };
    if (error) { <p>{error}</p> };
    if (videoId == null) { <p style={{ color: "red" }}>*Attachments are not available.</p> };

    return (
        <div>
            {videoId ? (
                otp && playbackInfo ? (
                    <iframe
                        src={`https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}&primaryColor=4245EF`}
                        frameBorder="0"
                        id="iframe"
                        allowFullScreen
                        title="Video Player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        loading="lazy"
                        style={{ width: '100%', height: '320px' }}
                    />
                ) : (
                    <p className='p-2'>Loading video...</p>
                )
            ) : contentProviderType === "Weblink" ? (<p style={{ color: "blue", padding: "5px", fontSize: "18px" }}>This content is playing in new tab!!</p>)
                : (
                    <iframe
                        src={`https://www.youtube-nocookie.com/embed/${youtubeVideoId}?autoplay=1`}
                        frameBorder="0"
                        id="iframe"
                        allowFullScreen
                        title="YouTube Player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        loading="lazy"
                        style={{ width: '100%', height: '320px' }}
                    />
                )}
        </div>
    );
}

export default PlayerComponent